// extracted by mini-css-extract-plugin
export default {"wraperNavigation":"styles_wraperNavigation__KKQaR","active":"styles_active__Xb9WQ"};